import { useState } from 'react'
import { useSelector } from 'react-redux'
import { Translate } from 'react-redux-i18n'
import { Element } from '../../../../../common/html/element'
import { COMPONENTS } from '../../../../../routers/constants'
import { LinkComponent } from '../../../../common/html/LinkComponent'
import { TYPE_SCORE } from '../../constants'
import '../../index.scss'
import { selectPortfolio } from '../../store/slice'
import { PieChartScore } from './PieChartScore'

const styles = {
  ACTIVE: {
    color: '#FFFFFF',
    backgroundColor: '#2C73E8',
    padding: '2px 8px',
  },
  NORMAL: {
    color: '#191D25',
    backgroundColor: '#F3F3F3',
    padding: '2px 8px',
  },
  CREDIT: '2px 0px 0px 2px',
  PERFORMANCE: '0px 2px 2px 0px',
}

export const ChartContainer = () => {
  const [typeScore, setTypeScore] = useState(TYPE_SCORE.CREDIT)

  const dataSaved = useSelector(selectPortfolio('data'))

  //Actions
  const handleChangeType = (type) => {
    setTypeScore(type)
  }

  return (
    <div className="h100 flexColumn w100">
      <div className="dFlex" style={{ paddingTop: 4, paddingBottom: 14 }}>
        {Object.keys(TYPE_SCORE).map((item, index) => (
          <Element
            key={index}
            className="cursorPointer textCenter"
            style={
              typeScore === TYPE_SCORE[item]
                ? {
                    ...styles.ACTIVE,
                    borderRadius:
                      typeScore === TYPE_SCORE.CREDIT
                        ? styles.CREDIT
                        : styles.PERFORMANCE,
                  }
                : styles.NORMAL
            }
            onClick={() => handleChangeType(TYPE_SCORE[item])}
          >
            <Translate value={TYPE_SCORE[item]} />
          </Element>
        ))}
      </div>

      {dataSaved.length ? (
        <div className="flex1 dFlex alignItemsCenter yourPortfolio w100">
          <PieChartScore type={typeScore} />
        </div>
      ) : (
        <div className="flex1 dFlex alignItemsCenter justifyContentCenter">
          <LinkComponent
            href={
              COMPONENTS.library.components.savedPortfolios.components
                .savedPortfolio.route
            }
          >
            <Element
              style={{
                color: '#2C73E8',
              }}
            >
              <Translate value="dashboard.yourPortfolio.createPort" />
            </Element>
          </LinkComponent>
        </div>
      )}
    </div>
  )
}
